import { type PropsWithChildren } from 'react';
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints';
import QuickSearchBarDesktop from '@/scopes/search/components/QuickSearchBar/QuickSearchBarDesktop';
import QuickSearchBarMobile from '@/scopes/search/components/QuickSearchBar/QuickSearchBarMobile';
import { css, styled } from 'styled-components';
import { tk } from '@sunwebgroup/ui-components';

export function QuickSearchContent({
  children,
  disabled,
}: PropsWithChildren<{
  disabled?: boolean;
}>) {
  const { isDesktopSm } = useBreakpoints();

  return (
    <>
      {isDesktopSm ? (
        <QuickSearchBarDesktop disabled={disabled}>{children}</QuickSearchBarDesktop>
      ) : (
        <QuickSearchBarMobile>{children}</QuickSearchBarMobile>
      )}
    </>
  );
}

export const Bar = styled.div<{ $isDesktop: boolean; $isSticky: boolean }>`
  ${({ $isSticky }) => $isSticky && isStickyMod()}
`;

const isStickyMod = () => css`
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;

  ${QuickSearchBarDesktop} {
    ${QuickSearchBarDesktop.isFullWidthMod()}
  }

  ${QuickSearchBarMobile} {
    ${QuickSearchBarMobile.isFullWidthMod()}
  }
`;

export const QuickSearchDrawer = styled.div`
  background-color: ${tk('color_semantic_bg')};
  border-radius: ${tk('radius_extra_large')};
  box-shadow: ${tk('shadow_md_bottom')};
  left: 0;
  min-height: 300px;
  overflow: hidden;
  padding: ${tk('spacing_md')};
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
`;
